<template>
    <li v-if="items.length >= 1" class="filter-category" v-click-outside="closeWindow">
        <div class="filter-category-title" @click="toggleViewOptions" :class="{ 'filter-category-title-open': showFilters }">
            <div class="filter-category-title-name-wrapper">
                <div class="filter-category-title-name">{{ title }}</div>
                <div class="filter-category-title-selected">
                    {{ __('frontend_js.category.selected') }} ({{ selected.length }})
                </div>
            </div>

            <div v-if="showFilters" class="filter-category-options" ref="optionsEl" @click.stop="">
                <div class="filter-category-options-wrapper">
                    <div class="filter-category-options-flex">
                        <store-filter-item
                            v-for="item in items"
                            :key="item.id"
                            v-model="form[item.id]"
                            :item="item"
                            :data-key="dataKey"
                            :is-current-filter-active="isCurrentFilterActive"
                            :stores-by-other-filters="storesByOtherFilters"
                        />
                    </div>
                    <div class="filter-category-option-close close-icon" @click.stop="showFilters = false"></div>
                </div>

                <div class="filter-category-option-button">
                    <button class="text-uppercase shop-button" @click.stop="filter">
                        {{ __('frontend_js.category.select') }}
                    </button>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: { required: true },
        dataKey: { required: true },
    },

    data() {
        return {
            form: {},
            showFilters: false,
        };
    },

    computed: {
        ...mapGetters('store-filters', ['filterData', 'storesForFilter', 'filters']),
        items() {
            return this.filterData[this.dataKey];
        },
        selected() {
            return this.filters[this.dataKey];
        },
        isCurrentFilterActive() {
            return this.selected.length > 0;
        },
        storesByOtherFilters() {
            let storesByOtherFilters = this.storesForFilter;

            for (const filterKey in this.filters) {
                // Filtering by all filters except current
                if (filterKey == this.dataKey) continue;
                if (this.filters[filterKey].length == 0) continue;

                storesByOtherFilters = storesByOtherFilters.filter(store => {
                    for (const attribute of store[filterKey]) {
                        if (this.filters[filterKey].includes(attribute.id)) {
                            return true;
                        }
                    }

                    return false;
                });
            }

            return storesByOtherFilters;
        },
    },

    created() {
        this.setChecked();

        this.$root.$on('close-filter-options', () => {
            this.showFilters = false;
        });
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.setChecked();
            },
        },
    },

    methods: {
        toggleViewOptions() {
            if (this.showFilters) {
                this.showFilters = false;
            } else {
                // close other filter options
                this.$root.$emit('close-filter-options');
                this.showFilters = true;
            }
        },
        setChecked() {
            const form = {};

            for (const item of this.items) {
                if (this.selected.some(id => id == item.id)) form[item.id] = true;
                else form[item.id] = false;
            }

            this.form = form;
        },
        filter() {
            const newFilterArr = [];

            for (const itemId in this.form) {
                if (!this.form[itemId]) continue;
                newFilterArr.push(parseInt(itemId));
            }

            // Check if filter was changed
            if (JSON.stringify(this.filters[this.dataKey].sort()) === JSON.stringify(newFilterArr.sort())) return;

            this.$store.commit('store-filters/SET_FILTER', {
                key: this.dataKey,
                value: newFilterArr,
            });

            this.$root.$emit('filterChanged');

            this.showFilters = false;
        },
        closeWindow() {
            if (this.showFilters == true) this.showFilters = false;
        },
        // closeWindow() {
        //     if (this.$refs.optionsEl.style?.display == 'block') {
        //         this.filter();
        //     }
        // },
    },
};
</script>

<style lang="scss" scoped></style>
